/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/structural_template/canvas_template_rename" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplateRenameCacheKeys } from "./constants";
import type {
  PutEngagementAppGroupIdStructuralTemplateCanvasTemplateRenameProps,
  EngagementAppGroupIdStructuralTemplateCanvasTemplateRenameResult,
} from "./types";

export const putEngagementAppGroupIdStructuralTemplateCanvasTemplateRename = reactQueryMutationAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplateRenameCacheKeys,
  ({
    appGroupId,
    templateId,
    templateName,
  }: PutEngagementAppGroupIdStructuralTemplateCanvasTemplateRenameProps): Promise<EngagementAppGroupIdStructuralTemplateCanvasTemplateRenameResult> => {
    // manipulate props here as needed { templateId, templateName }

    return fetch(
      `/engagement/${appGroupId}/structural_template/canvas_template_rename`,
      "PUT",
      {
        app_group_id: appGroupId,
        template_id: templateId,
        template_name: templateName,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
